import { render, staticRenderFns } from "./ReturnDocument.vue?vue&type=template&id=2615bb55&"
import script from "./ReturnDocument.vue?vue&type=script&lang=js&"
export * from "./ReturnDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports